import { Component, inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogActions, MatDialogContent, MatDialogRef, MatDialogTitle } from '@angular/material/dialog';
import { TranslatePipe } from '@ngx-translate/core';
import { LanguageService } from '../../../core/services/language/language.service';
import { Downtime } from '../../../core/services/times/downtime';
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'app-greeting-window',
  imports: [TranslatePipe, MatDialogTitle, MatDialogContent, MatDialogActions],
  templateUrl: './greeting-window.html',
  styleUrl: './greeting-window.scss'
})
export class GreetingWindow implements OnInit{
  readonly dialogRef = inject(MatDialogRef<GreetingWindow>);
  data = inject(MAT_DIALOG_DATA);
  language = inject(LanguageService);
  private listPrefix: any = [];
    downtime = inject(Downtime);
  public settings = environment;


  onNoClick(){
    this.downtime.refreshTimer();
    this.dialogRef.close();
  }

  prefixBeforeTitle(count: number = 1){
    return ((this.listPrefix[this.language.appLanguage as string].length-1) >= count)?this.listPrefix[this.language.appLanguage as string][count]:this.listPrefix[this.language.appLanguage as string][this.listPrefix.length-1];
  }

  ngOnInit(): void {
    this.listPrefix["ru"] = ["","","Топ ","Супер ","Мега ","Ультра ","Гипер ","Гипер ","Гипер ","Гипер ","Гипер ","Гипер ","Гипер ","Гипер ","Гипер ","Гипер ","Гипер ","Гипер ","Гипер ","Гипер ","Гипер "];
    this.listPrefix["uk"] = ["","","Топ ","Супер ","Мега ","Ультра ","Гіпер ","Гіпер ","Гіпер ","Гіпер ","Гіпер ","Гіпер ","Гіпер ","Гіпер ","Гіпер ","Гіпер ","Гіпер ","Гіпер ","Гіпер ","Гіпер ","Гіпер "];
    this.listPrefix["en"] = ["","","Top ","Super ","Mega ","Ultra ","Hyper ","Hyper ","Hyper ","Hyper ","Hyper ","Hyper ","Hyper ","Hyper ","Hyper ","Hyper ","Hyper ","Hyper ","Hyper ","Hyper ","Hyper "];
    this.dialogRef.disableClose = true;
  }

  clickIconClose(event: MouseEvent){
    this.onNoClick();
  }

}
